import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { ProjectCard } from '@/app/donation/_components/ProjectCard';
import { SPECIFIC_DONATION_STATUS } from '@/app/donation/constants';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SectionTitle } from '../SectionTitle';
interface ProjectsContentProps {
  institutionId: number;
}
const PAGE_SIZE = 3;

/** 지정기부 content */
export const ProjectsContent = t0 => {
  const $ = _c(10);
  const {
    institutionId
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("mb-32", "mobile-tablet:mb-12");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isDesktopViewport ? "\uC9C0\uC815\uAE30\uBD80\uC0AC\uC5C5" : "\uC9C0\uC815\uAE30\uBD80";
  let t3;
  if ($[1] !== t2) {
    t3 = <SectionTitle className={t1}>{t2}</SectionTitle>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("grid grid-cols-3 gap-x-18 gap-y-16", "mobile-tablet:grid-cols-1");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <InfiniteListMoreButton className={cn("mt-40", "mobile-tablet:mt-16")} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== institutionId) {
    t6 = <div className={t4}><InfiniteListWithMoreButton moreButtonComponent={t5} queryKey={[...UnauthQueryKey["get:/wello/v2/allows/home/donation-business"](), institutionId, PAGE_SIZE]} queryFn={t7 => {
        const {
          pageParam
        } = t7;
        return UnauthApi["get:/wello/v2/allows/home/donation-business"]({
          query: {
            institutionId,
            page: pageParam,
            size: PAGE_SIZE
          }
        }).then(_temp);
      }} pageSize={PAGE_SIZE} renderItem={_temp2} getItemKey={_temp3} /></div>;
    $[5] = institutionId;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t6) {
    t7 = <div>{t3}{t6}</div>;
    $[7] = t3;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
function _temp(data) {
  return data.data?.context?.contents ?? [];
}
function _temp2(item) {
  return <ProjectCard daysLeft={item.dday} donationAmount={item.donationAmount} thumbnailUrl={item.thumbnailUrl} title={item.donationBusinessName} achievementRate={item.achievementRate} businessId={item.donationBusinessId} slugId={item.donationBusinessSlugId} isEnded={item.specificDonationStatus === SPECIFIC_DONATION_STATUS.ENDED} />;
}
function _temp3(item_0) {
  return item_0.donationBusinessId;
}